import { NgModule } from '@angular/core';

import { GetFieldInFormPipe } from './get-field-in-form.pipe'
import { GetArrayInFormPipe } from './get-array-in-form.pipe';
import { GetGroupInFormPipe } from './get-group-in-form.pipe';



@NgModule({
  declarations: [
    GetFieldInFormPipe,
    GetGroupInFormPipe,
    GetArrayInFormPipe
  ],
  exports: [
    GetFieldInFormPipe,
    GetGroupInFormPipe,
    GetArrayInFormPipe
  ]
})
export class GetFieldInFormModule { }
